<template>
  <div class="pinwall__list">
    <button class="add" title="Add Pinwall" @click.stop.prevent="goToPinwall()"><i class="material-icons">add</i></button>
    <button class="refresh" title="Refresh Pinwalls" @click.stop.prevent="$emit('refresh')"><i class="material-icons">refresh</i></button>
    <input placeholder="Filter pinwalls" type="text" v-model="textFilter" />
    <ul>
      <li @click.stop.prevent="open(item)" class="pinwall__list__item" title="Select pinwall" v-for="item in filteredPinwalls" v-bind:key="item.id" :style="'background:url(' +  item.image + ') no-repeat center center'">
        <div class="title" :class="item.id === selectedPinwall.id ? 'selected-title' : ''"><i style="font-size:17px;margin-right:4px" v-if="item.private" class="material-icons">lock</i><span>{{item.name !== undefined ? item.name.substring(0, 25) : ''}}</span></div>
        <div class="pinwall__list__item__buttom">
          <button class="pinwall__list__item__buttom__btn" title="Edit Pinwall" @click.stop.prevent="openPinwall(item)"><i class="material-icons">edit</i></button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { pinwallUrl } from '../../config'

export default {
  name: 'list',
  props: {
    items: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(['selectedPinwall', 'user']),
    filteredPinwalls() {
      const items = this.items
      return items.filter((item, i, arr) => {
        return (item.name || '').toLowerCase().indexOf((this.textFilter || '').toLowerCase()) >= 0
      })
    }
  },
  data: () => ({
    textFilter: null
  }),
  methods: {
    ...mapActions(['setPinwall']),
    open(item) {
      this.setPinwall(item)
    },
    goToPinwall() {
      let url = pinwallUrl
      if (this.user.tenantName !== '' && this.user.tenantName !== 'swisstxt') {
        url = url.replace('http://', `http://${this.user.tenantName}.`)
      }
      window.open(url, '_blank');
    },
    openPinwall(item) {
      let url = ''
      if (item.password && item.password !== '') {
        url = `${pinwallUrl}${item.id}?pw=${item.password}`
      } else {
        url = pinwallUrl + item.id
      }

      if (this.user.tenantName !== '' && this.user.tenantName !== 'swisstxt') {
        url = url.replace('http://', `http://${this.user.tenantName}.`)
      }
      window.open(url, '_blank');
    }
  }
}
</script>
